import { useDisclosure, Button, HStack } from '@ritualco/jutsu'
import {
  useAddMerchantToMerchantList,
  useDeleteMerchantFromMerchantList,
} from 'api/endpoints/merchantLists'
import { ReactComponent as AddIcon } from 'assets/Icons/Plus.svg'
import { ReactComponent as ReOrderIcon } from 'assets/Icons/Unfold.svg'
import { EditableSection } from 'components/EditableSection'
import { MerchantListManageModal } from 'components/Modals/MerchantListManageModal'
import { MerchantListReorderModal } from 'components/Modals/MerchantListReorderModal'
import { RestaurantsTable } from 'components/Tables/RestaurantsTable'
import { useContent } from 'lib/content/react'
import { Merchant } from 'types/entities'

type ListSectionProps = {
  organizationId: string
  workspaceId: string
  merchantListId: string
  merchants: Merchant[]
}

export const ListSection = ({
  organizationId,
  workspaceId,
  merchantListId,
  merchants,
}: ListSectionProps) => {
  const { formatMessage } = useContent()
  const {
    isOpen: isReorderOpen,
    onOpen: onReorderOpen,
    onClose: onReorderClose,
  } = useDisclosure()
  const {
    isOpen: isManageOpen,
    onOpen: onManageOpen,
    onClose: onManageClose,
  } = useDisclosure()
  const add = useAddMerchantToMerchantList()
  const remove = useDeleteMerchantFromMerchantList()

  const showReorderButton = merchants.length > 1

  return (
    <>
      <EditableSection
        title={formatMessage({
          id: 'pmportal.restaurantLists.restaurantListTitle',
        })}
        action={
          <HStack>
            {showReorderButton && (
              <Button
                colorScheme="transparent"
                variant="outline"
                leftIcon={<ReOrderIcon style={{ height: 18, width: 18 }} />}
                onClick={onReorderOpen}
              >
                {formatMessage({
                  id: 'pmportal.restaurantLists.reorderAction',
                })}
              </Button>
            )}
            <Button
              colorScheme="transparent"
              variant="outline"
              leftIcon={<AddIcon style={{ height: 18, width: 18 }} />}
              onClick={onManageOpen}
            >
              {formatMessage({
                id: 'pmportal.restaurantLists.manageRestaurantsAction',
              })}
            </Button>
          </HStack>
        }
        pt={12}
      >
        <RestaurantsTable merchants={merchants} />
      </EditableSection>
      <MerchantListReorderModal
        merchants={merchants}
        isOpen={isReorderOpen}
        onClose={onReorderClose}
        onReorder={(startIndex, endIndex) => {
          add.mutate({
            organizationId,
            workspaceId,
            merchantListId,
            merchantListEntry: {
              merchantId: merchants[startIndex].id,
              index: endIndex,
            },
          })
        }}
      />
      <MerchantListManageModal
        organizationId={organizationId}
        workspaceId={workspaceId}
        merchants={merchants}
        isOpen={isManageOpen}
        onClose={onManageClose}
        onAdd={merchantId => {
          add.mutate({
            organizationId,
            workspaceId,
            merchantListId,
            merchantListEntry: {
              merchantId: merchantId,
            },
          })
        }}
        onRemove={merchantId => {
          remove.mutate({
            organizationId,
            workspaceId,
            merchantListId,
            merchantId,
          })
        }}
      />
    </>
  )
}
